import { render, staticRenderFns } from "./VvScreenWrapper.vue?vue&type=template&id=5584f242&scoped=true&"
import script from "./VvScreenWrapper.vue?vue&type=script&lang=js&"
export * from "./VvScreenWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5584f242",
  null
  
)

export default component.exports